document.addEventListener('DOMContentLoaded', function () {
  var floatingItems = document.querySelectorAll('.floating-item');

  floatingItems.forEach(function (item, index) {
    let currentTranslateY = 0;
    let targetTranslateY = 0;

    const speedMultiplier = 0.08 + Math.random() * 0.05;
    const delayFactor = 20 + Math.random() * 10;

    const maxMovePx = 150;
    const direction = index % 2 === 0 ? 1 : -1;

    function animate() {
      currentTranslateY += (targetTranslateY - currentTranslateY) * speedMultiplier;
      item.style.transform = 'translate3d(0px, ' + currentTranslateY + 'px, 0px)';

      requestAnimationFrame(animate);
    }

    window.addEventListener('scroll', function () {
      var scrollTop = window.scrollY;
      let rawTargetTranslateY = (scrollTop / delayFactor) * direction;

      targetTranslateY = Math.max(
        -maxMovePx,
        Math.min(rawTargetTranslateY, maxMovePx),
      );
    });

    animate();
  });
});